module.exports = __webpack_public_path__ + "img/header-bg.4e5680c2.jpg";